import React from "react";
import Navbar from '../components/Navbar';
import { Container } from "react-bootstrap";
import BookInfo from '../components/BookInfo/BookInfo';
import Footer from '../components/Footer';

export default function Book() {

  return (
    <div>
      <Navbar />
      <div className="background">
        <Container>
          <BookInfo />
        </Container>
      </div>
      <Footer />
    </div>
  );
}
